export default __webpack_public_path__ + "static/media/tv.d546c90e.svg";